<template>
    <div class="card h-auto mt-4">
        <div class="py-3 d-flex align-items-center justify-content-center border-bottom">
            <div class="d-flex align-items-center">
                <div class="mx-3 text-center">
                    <a href="javascript:;" class="text-sm text-dark font-weight-600 segment-primary-color">{{ contractData ?
                    contractData.nome : null }}</a>
                    <small class="d-block text-muted">{{ contractData ? contractData.contrato_unidade : null }}</small>
                </div>
            </div>
        </div>
        <div v-if="!financialSumary" class="d-flex justify-content-center align-items-center col-12"
            style="height: 100px;top: 0;left: 0;">
            <p class="text-center"><i class="fas fa-spinner fa-pulse"></i> Aguarde</p>
        </div>
        <div v-else class="row mt-2 mb-2 mx-3">
            <div class="col-6">
                <div class="row d-flex justify-content-start mt-2 line">Número do contrato</div>
                <div class="row d-flex justify-content-start mt-2 line bg-custom">Valor do contrato</div>
                <div class="row d-flex justify-content-start mt-2 line">Valor pago</div>
                <div class="row d-flex justify-content-start mt-2 line bg-custom">Valor a pagar corrigido</div>
            </div>
            <div class="col-6 font-weight-bolder">
                <div class="row d-flex justify-content-end mt-2 line">{{ financialSumary.contrato }}</div>
                <div class="row d-flex justify-content-end mt-2 line bg-custom">{{
                    financialSumary.valor_contrato_formatado }}</div>
                <div class="row d-flex justify-content-end mt-2 line">{{ financialSumary.valor_pago_formatado }}</div>
                <div class="row d-flex justify-content-end mt-2 line bg-custom">{{
                    financialSumary.total_devido_formatado }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, computed, ref } from 'vue';
import axios from "axios";
import { useStore } from "vuex";

const store = useStore();
const financialSumary = ref(null)
const contractData = computed(() => store.getters.getCurrentContract);

onMounted(() => {
    getFinancialSumary();
});

const getFinancialSumary = async () => {
    const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/financial-summary`);
    financialSumary.value = response.data
}

</script>

<style scoped>
.bg-custom {
    background-color: #FAFAFA;
}

.line {
    padding-left: 5px;
    padding-right: 5px;
    /* border-radius: 5px; */
    white-space: nowrap;
}
</style>